import styled from "styled-components";
import Dialog from "../../../components/dialog/dialog";

export const CreateCompanyModalStyled = styled(Dialog)`
  width: 55%;
  /* height: 80%; */
  
  button{
    color: #301d35 !important;
    border: 1px solid #301D35;
  }
  button:hover{
    background-color: #dedafb !important;
  }
  .head {
    margin: 12px 0
  }
  .hr{
    margin: 5px 0px 0px 0px;
    border-bottom: 1px solid #dedafb !important;
    border: none;
  }
  .dialog-body {
    padding: 16px;
  }
`;
